import API from '../api'
import { CalendarEvent } from './calendarModel'

export const CalendarEndpoint = '/calendar'

export const getConsultationCalendarEvents = async (customerId: number | undefined): Promise<CalendarEvent[]> => {
  return (await API.get(`${CalendarEndpoint}?customerId=${customerId}`)).data
}